import script from "./EventCardLarge.vue?vue&type=script&setup=true&lang=js"
export * from "./EventCardLarge.vue?vue&type=script&setup=true&lang=js"

import "./EventCardLarge.vue?vue&type=style&index=0&id=6b69d8a2&lang=scss&scoped=true"
import "./EventCardLarge.vue?vue&type=style&index=1&id=6b69d8a2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b69d8a2"]])

export default __exports__